import React, { Component } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import { connect } from 'react-redux';
import { ArrowLeft } from '../../../assets/icons';
import moment from 'moment';
import './VerifyRequestPage.css';
import AlertBox from '../../../components/AlertBox';

// Redux Actions
import GetLeaveActions from '../../../redux/GetLeaveRedux';
import ApplyLeaveActions from '../../../redux/ApplyLeaveRedux';
import GetCheckSickNoteActions from '../../../redux/GetCheckSickNoteRedux';
import CreateMakeUpSessionActions from '../../../redux/CreateMakeUpSessionRedux';

// Navigation parameters interface
interface VerifyRequestPageProps {
  t?: TFunction;
  navigate?: (path: string, params?: any) => void;
  goBack?: () => void;
  
  // Navigation parameters (from URL query strings)
  leave_id?: string | null;
  categoryId?: string | null;
  childId?: string | null;
  checkLeave?: string | null;
  
  // Location object for URL parameters
  location?: {
    search: string;
    pathname: string;
  };
  
  // Redux Props
  currentSettings?: any;
  children?: any;
  getLeaveFetching?: boolean;
  getLeaveSuccess?: boolean;
  getLeaveError?: boolean;
  dataLeave?: any;
  listFile?: any;
  status?: any;
  applyLeaveFetching?: boolean;
  applyLeaveSuccess?: boolean;
  applyLeaveError?: boolean;
  applyLeaveStatus?: any;
  createMakeUpSessionSuccess?: boolean;
  createMakeUpSessionFetching?: boolean;
  makeupdata?: any;
  checkSickNote?: any;
  
  // Redux Actions
  getLeave?: (leave_id: string) => void;
  applyLeave?: (leave_id: string) => void;
  getCheckSickNote?: (leave_id: string) => void;
  createMakeUpSession?: (children_id: string) => void;
}

interface VerifyRequestPageState {
  isLoading: boolean;
  categoryId: string | null;
  childId: string | null;
  checkMake: boolean;
  isRefreshing: boolean;
  alertPopupOpen: boolean;
  alertMessage: string;
}

class VerifyRequestPage extends Component<VerifyRequestPageProps, VerifyRequestPageState> {
  constructor(props: VerifyRequestPageProps) {
    super(props);
    
    // Parse URL parameters
    const urlParams = this.parseUrlParams();
    
    this.state = {
      isLoading: false,
      categoryId: urlParams.categoryId || this.props.categoryId || null,
      childId: urlParams.childId || this.props.childId || null,
      checkMake: false,
      isRefreshing: false,
      alertPopupOpen: false,
      alertMessage: '',
    };
  }

  // Utility function to parse URL parameters
  parseUrlParams = () => {
    const params: { [key: string]: string | null } = {};
    
    if (this.props.location?.search) {
      const searchParams = new URLSearchParams(this.props.location.search);
      params.leave_id = searchParams.get('leave_id');
      params.categoryId = searchParams.get('categoryId');
      params.childId = searchParams.get('childId');
      params.checkLeave = searchParams.get('checkLeave');
    }
    
    return params;
  }

  // Lifecycle methods
  componentDidMount() {
    // Get URL parameters
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;
    
    // Get leave details and check sick note
    if (leave_id) {
      this.props.getCheckSickNote?.(leave_id);
      this.props.getLeave?.(leave_id);
    }
  }

  componentDidUpdate(prevProps: VerifyRequestPageProps) {
    // Handle refresh state
    if (this.state.isRefreshing && !this.props.getLeaveFetching && prevProps.getLeaveFetching) {
      this.setState({ isRefreshing: false });
    }
    
    // Handle apply leave success/error responses
    if (!this.props.applyLeaveFetching) {
      if (this.props.applyLeaveSuccess && this.props.applyLeaveSuccess !== prevProps.applyLeaveSuccess) {
        if (this.props.status?.success === false) {

          // alert(this.props.status?.message || 'Error occurred');
          // this.props.navigate?.('/calendar');
          this.setState({ alertPopupOpen: true, alertMessage: (this.props.status?.message || 'Error occurred'), checkMake: false });
          // checkMake false - reset to false

        } else {
          // alert(this.props.t?.('verify-request:message-succes') || 'Leave request submitted successfully');
          let alertMessage = this.props.t?.('verify-request:message-succes') || 'Leave request submitted successfully';
          if (this.props.status?.meta?.type === 'sick-missing') {
            const reminder = this.props.t?.('verify-request:message-sick-note-reminder')
              || 'Reminder: Sick notes must be submitted within 3 days of your sick leave.';
            alertMessage = `${alertMessage}\n\n${reminder}`;
          }
          this.setState({ alertPopupOpen: true, alertMessage });
          // if (this.state.checkMake) {
          //   this.props.navigate?.('/book-make-up-session', {
          //     code: 'book-a-make-up-session',
          //     leave_id: this.props.leave_id,
          //     make_id: this.props.makeupdata?.data?.id,
          //   });
          // } else {
          //   this.props.navigate?.('/calendar');
          // }
        }
      }
      
      if (this.props.applyLeaveError && this.props.applyLeaveError !== prevProps.applyLeaveError) {
        const errorMessage = this.props.status?.message || 'Leave application failed';
        alert(errorMessage);
      }
    }
  }

  alertSuccessOk = () => {
    this.setState({ alertPopupOpen: false, alertMessage: '' });

    if (this.state.checkMake) {
      this.props.navigate?.('/calendar/book-make-up-session', {
        code: 'book-a-make-up-session',
        leave_id: this.props.leave_id,
        make_id: this.props.makeupdata?.data?.id,
      });
    } else {
      this.props.navigate?.('/calendar');
    }
  }

  // Action methods
  back = () => {
    this.props.goBack?.();
  }

  applyLeavee = () => {
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;
    
    if (leave_id) {
      this.props.applyLeave?.(leave_id);
    } else {
      alert(this.props.status?.message || 'No leave ID available');
    }
  }

  applyLeaveBookMake = () => {
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;
    
    if (this.props.currentSettings?.child?.salesforce_contact_id) {
      this.props.createMakeUpSession?.(this.props.currentSettings.child.salesforce_contact_id);
    }
    
    if (leave_id) {
      this.props.applyLeave?.(leave_id);
    } else {
      alert(this.props.t?.('verify-request:message-error') || 'No leave ID available');
    }
  }

  _onRefresh = () => {
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;
    
    if (leave_id) {
      this.setState({ isRefreshing: true });
      this.props.getLeave?.(leave_id);
    }
  }

  // Touch handlers for pull-to-refresh
  private touchStartY = 0;
  private touchCurrentY = 0;
  private isPulling = false;

  handleTouchStart = (e: React.TouchEvent) => {
    this.touchStartY = e.touches[0].clientY;
    this.touchCurrentY = e.touches[0].clientY;
  }

  handleTouchMove = (e: React.TouchEvent) => {
    this.touchCurrentY = e.touches[0].clientY;
    const scrollElement = e.currentTarget;
    
    // Check if we're at the top of the scroll area
    if (scrollElement.scrollTop === 0) {
      const pullDistance = this.touchCurrentY - this.touchStartY;
      
      if (pullDistance > 50 && !this.isPulling) {
        this.isPulling = true;
        this._onRefresh();
      }
    }
  }

  handleTouchEnd = (e: React.TouchEvent) => {
    this.isPulling = false;
  }

  render() {
    const { t } = this.props;
    const { isLoading } = this.state;

    // Get URL parameters
    const urlParams = this.parseUrlParams();
    const leave_id = urlParams.leave_id || this.props.leave_id;
    const checkLeave = urlParams.checkLeave || this.props.checkLeave;

    // Use real Redux data - match reference implementation
    const dataLeave = this.props.dataLeave;
    
    // Show loading state - match reference implementation
    const isDataLoading = this.props.getLeaveFetching || false;
    const hasData = this.props.getLeaveSuccess && !this.props.getLeaveFetching && dataLeave;
    const isRefreshing = this.state.isRefreshing || this.props.getLeaveFetching;

    return (
      <div className="verifyrequest-page">
        {/* Header Section */}
          <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button
                className="header-button back-button"
                onClick={() => this.props.goBack?.()}
              >
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {t?.('verify-request:verify-request') || 'Verify Request'}
              </h1>
          </div>
            
            <div className="header-right">
              {/* Empty for now */}
            </div>
          </div>
        </div>

        {/* Content Section with Pull-to-Refresh */}
        <div className="page-content">
          <div className="request-description">
            <p>{t?.('verify-request:your-request') || 'Your request details:'}</p>
          </div>

          {/* Scrollable Content with Refresh */}
          <div 
            className={`scrollable-content ${isRefreshing ? 'refreshing' : ''}`}
            onTouchStart={this.handleTouchStart}
            onTouchMove={this.handleTouchMove}
            onTouchEnd={this.handleTouchEnd}
          >
            {/* Loading State */}
            {isDataLoading && !hasData && (
              <div className="loading-card">
                <div className="loading-spinner">
                  <span>{t?.('verify-request:loading') || 'Loading...'}</span>
                </div>
              </div>
            )}

            {/* Leave Details Card - Match reference conditional rendering */}
            {hasData ? (
              <div className="leave-details-card">
                <h3 className="card-title">
                  {t?.('verify-request:leave-request') || 'Leave Request'}
                </h3>
                
                <div className="details-section">
                  {/* Child Name - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('appointment-summary-screen:summary.item.name') || 'Name:'}{' '}
                    </span>
                    <span className="detail-value">
                      {dataLeave?.name ? dataLeave.name : ''}
                    </span>
                  </div>

                  {/* Date - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('appointment-summary-screen:summary.item.date') || 'Date:'}{' '}
                    </span>
                    <span className="detail-value">
                      {dataLeave?.date?.date ? 
                        moment(dataLeave.date.date).format('DD MMMM YYYY') : ''}
                    </span>
                  </div>

                  {/* Time - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('appointment-summary-screen:summary.item.time') || 'Time:'}{' '}
                    </span>
                    <span className="detail-value">
                      {dataLeave?.time ? dataLeave.time : ''}
                    </span>
                  </div>

                  {/* Therapist - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('select-leavere-quest:therapist') || 'Therapist:'}
                    </span>
                    <span className="detail-value">
                      {dataLeave?.therapist ? dataLeave.therapist : ''}
                    </span>
                  </div>

                  {/* Service Type - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('select-leavere-quest:service-type') || 'Service Type:'}{' '}
                    </span>
                    <span className="detail-value">
                      {dataLeave?.service_type ? dataLeave.service_type : ''}
                    </span>
                  </div>

                  {/* Leave Type - Match reference exactly */}
                  <div className="detail-row">
                    <span className="detail-label">
                      {t?.('select-leavere-quest:leave-type') || 'Leave Type:'}{' '}
                    </span>
                    <span className="detail-value">
                      {checkLeave === '0' ? 
                        (t?.('select-leavere-quest:other-leave') || 'Other Leave') :
                        (t?.('select-leavere-quest:sick-leave') || 'Sick Leave')
                      }
                    </span>
                  </div>

                  {/* View History Link - Match reference exactly */}
                  <div className="detail-row history-row">
                    <div className="history-left">
                      {/* Leave quota section - commented out in reference */}
                    </div>
                    <div className="history-right">
                      <button
                        className="history-link"
                        onClick={() => this.props.navigate?.('/calendar/type-history')}
                      >
                        {t?.('verify-request:view-history') || 'View History'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        {/* Action Buttons Section - Match reference exactly */}
        <div className="action-buttons">
          {/* Primary Apply Button - Match reference */}
          <button
            className="apply-button primary comman-btn w-100"
            onClick={this.applyLeavee}
            disabled={isLoading || this.props.applyLeaveFetching || !hasData}
          >
            <span>
              {isLoading || this.props.applyLeaveFetching ? 
                (t?.('verify-request:loading') || 'Loading...') :
                (t?.('verify-request:apply-leave') || 'Apply Leave')
              }
            </span>
          </button>

          {/* Conditional Make-up Session Button - Match reference exactly */}
          {dataLeave?.available_to_make_up_session && hasData && (
            <div className="makeup-session-section">
              {checkLeave !== '0' ? (
                <button
                  className="apply-button secondary disabled inactive-option comman-btn w-100"
                  disabled
                >
                  <span>
                    {t?.('verify-request:apply-leave-and-book-make-up-session') || 'Apply Leave and Book Make-Up Session'}
                  </span>
                </button>
              ) : (
                <button
                  className="apply-button secondary comman-btn w-100"
                  onClick={() => {
                    this.setState({ checkMake: true });
                    this.applyLeaveBookMake();
                  }}
                  disabled={isLoading || this.props.applyLeaveFetching}
                >
                  <span>
                    {t?.('verify-request:apply-leave-and-book-make-up-session') || 'Apply Leave and Book Make-Up Session'}
                  </span>
                </button>
              )}
            </div>
          )}
        </div>

        {/* Loading Overlay */}
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner">
              <span>{t?.('common:loading') || 'Loading...'}</span>
            </div>
          </div>
        )}

        <AlertBox
          title={t?.('common:message') || 'Message'}
          message={this.state.alertMessage}
          isVisible={this.state.alertPopupOpen}
          onClose={() => {}}
          okAction={this.alertSuccessOk}
          okText={t?.('common:ok') || 'OK'}
        />
      </div>
    );
  }
}

// Redux connection
const mapStateToProps = (state: any) => ({
  currentSettings: state.currentSettings,
  children: state.getChildren.children,
  getLeaveFetching: state.getLeave.fetching,
  getLeaveSuccess: state.getLeave.success,
  getLeaveError: state.getLeave.error,
  dataLeave: state.getLeave.dataLeave,
  listFile: state.getLeave.listFile,
  status: state.applyLeave.data,
  applyLeaveFetching: state.applyLeave.fetching,
  applyLeaveSuccess: state.applyLeave.success,
  applyLeaveError: state.applyLeave.error,
  applyLeaveStatus: state.applyLeave.status,
  createMakeUpSessionSuccess: state.createMakeUpSession.success,
  createMakeUpSessionFetching: state.createMakeUpSession.fetching,
  makeupdata: state.createMakeUpSession.makeupdata,
  checkSickNote: state.getCheckSickNote.checkSickNote,
});

const mapDispatchToProps = (dispatch: any) => ({
  getLeave: (leave_id: string) => dispatch(GetLeaveActions.getLeaveRequest(leave_id)),
  applyLeave: (leave_id: string) => dispatch(ApplyLeaveActions.applyLeaveRequest(leave_id)),
  getCheckSickNote: (leave_id: string) => dispatch(GetCheckSickNoteActions.getCheckSickNoteRequest(leave_id)),
  createMakeUpSession: (children_id: string) => dispatch(CreateMakeUpSessionActions.createMakeUpSessionRequest(children_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VerifyRequestPage));
